import type { ContactSectionConfigType } from '@/components/sections/ContactSection';
import type { ImagesItemsSectionConfigType } from '@/components/sections/ImagesItemsSection';
import type { ItemsContainerSectionProps } from '@/components/sections/ItemsContainerSection';

import { CONTACT_SECTION_CONFIG } from './common';

import { env } from '@/env.mjs';

type PopupContentType = {
    modalTitle: string;
    orderedCardSection: ItemsContainerSectionProps;
    imagesItemsSection: ImagesItemsSectionConfigType;
    contactSection: ContactSectionConfigType;
};

export const POPUP_CONFIG_PL: PopupContentType = {
    modalTitle: 'Jak działa PayPo?',
    orderedCardSection: {
        headerContentText: {
            textConfig: [
                {
                    type: 'heading3',
                    text: 'Kup teraz, zapłać za 30 dni',
                    className: 'text-xl md:text-4xl text-center heading-spaces',
                },
            ],
        },
        containerConfig: {
            flexOptions: {
                preset: 'full',
            },
        },
        items: [
            {
                type: 'ordered-card',
                config: {
                    'data-test-id':
                        'popup-section-how-it-works-tab-content-ordered-card-1',
                    className: 'w-full !mb-6',
                    number: '1',
                    numberBgColor: 'bg-green-500',
                    content:
                        'Robiąc zakupy w sklepie, <b>wybierasz PayPo jako formę płatności za Twoje zamówienie</b>.',
                },
            },
            {
                type: 'ordered-card',
                config: {
                    'data-test-id':
                        'popup-section-how-it-works-tab-content-ordered-card-2',
                    className: 'w-full !mb-6',
                    number: '2',
                    numberBgColor: 'bg-yellow-600',
                    content:
                        'Jeśli nie masz konta w PayPo, to <b>podajesz swoje dane</b>. Kolejne zakupy potwierdzasz <b>kodem SMS lub w aplikacji mobilnej</b>.',
                },
            },
            {
                type: 'ordered-card',
                config: {
                    'data-test-id':
                        'popup-section-how-it-works-tab-content-ordered-card-3',
                    className: 'w-full',
                    number: '3',
                    numberBgColor: 'bg-brand-fuchsia',
                    content:
                        '<b>PayPo opłaca Twoje zamówienie</b> w sklepie, a Ty spłacasz je później - <b>za 30 dni, bez dodatkowych kosztów</b>.',
                },
            },
        ],
    },
    imagesItemsSection: {
        title: [
            {
                type: 'heading4',
                text: 'Korzyści',
                className: 'text-lg md:text-3xl text-center heading-spaces',
            },
        ],
        columns: 2,
        list: [
            {
                id: '1',
                image: {
                    src: '/images/icons/calendar.svg',
                    alt: 'Ikona kalendarza',
                },
                description:
                    '<b>Masz aż 30 dni na zapłatę</b> - bez dodatkowych kosztów',
            },
            {
                id: '2',
                image: {
                    src: '/images/icons/package.svg',
                    alt: 'Ikona paczki',
                },
                description:
                    '<b>Planujesz swoje wydatki</b> - płatność za zakupy rozciągasz w czasie i nie nadwyrężasz portfela, gdy akurat masz większe wydatki',
            },
            {
                id: '3',
                image: {
                    src: '/images/icons/holding-gift.svg',
                    alt: 'Ikona prezentu',
                },
                description:
                    '<b>Możesz pozwolić sobie na więcej</b> - zaszaleć na wyprzedażach lub kupić prezent sobie czy bliskim, a płatność za zakupy rozciągnąć w czasie',
            },
            {
                id: '4',
                image: {
                    src: '/images/icons/bag-security.svg',
                    alt: 'Ikona bezpieczeństwo zakupów',
                },
                description:
                    '<b>Robisz pewne zakupy</b> - sprawdzasz zamówienie, a płacisz później, gdy jesteś już pewny zakupu',
            },
        ],
        additionalText: `Usługa jest dostępna dla nowych klientów PayPo. Informacja nie stanowi oferty. Szczegóły w Regulaminie usługi “Zapłać za 30 dni” dostępnym na <a href="${env.NEXT_PUBLIC_APP_URL}/p/regulaminy" className="text-green-600">paypo.pl/p/regulaminy</a>. Klienci PayPo po spłaceniu jednej transakcji w całości, zaczynają korzystać z usług, które umożliwiają spłatę zamówienia w ciągu 30 dni lub w ratach.`,
    },
    contactSection: {
        isPopup: true,
        ...CONTACT_SECTION_CONFIG,
    },
};
